<template>
  <div>
    <Navbar />
    <section class="category-page">
      <Header
        formID="get-offer-travel"
        :formData="formData"
        :insuranceType="insuranceType"
        approveRoute="seyahat-saglik-teklif-onay"
      />
      <get-quote :quoteCard="quoteCard" />
      <category-info :categoryInfo="categoryInfo" />
      <app-contracted-insurance-companies :buttons="buttonData" />
      <frequently-asked-questions
        :faqTitle="faqTitle"
        :faqTitleDesc="faqTitleDesc"
        :questions="questions"
      />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Header from '@/component/categories/Header'
import GetQuote from '@/component/categories/GetQuote'
import categoryInfo from '@/component/categories/CategoryInfo'
import appContractedInsuranceCompanies from '@/component/contracted-insurance-companies/AppContractedInsuranceCompanies'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import TravelHealthData from '@/data/category-page-data/TravelHealthInsurance'
import Footer from '@/component/footer/Footer'
import QuotationType from '@/data/QuotationType'
import { filteredButtons } from '@/mixins/FilteredButtons'

export default {
  metaInfo: {
    title: 'En Ucuz Seyahat Sağlık Sigortası Teklifini Alın',
    meta: [
      {
        name: 'description',
        content:
          'Seyahatinizi güvence altına alacak yurt dışı seyahat sağlık sigortası ve yurtiçi seyahat sağlık sigortası fiyatları için tıklayınız, poliçenizi hemen satın alın.'
      }
    ]
  },
  mixins: [filteredButtons],
  name: 'TravelHealthInsurance',
  components: {
    Navbar,
    Header,
    GetQuote,
    categoryInfo,
    appContractedInsuranceCompanies,
    frequentlyAskedQuestions,
    Footer
  },
  data () {
    return {
      insuranceType: QuotationType.TRAVEL,
      categoryInfo: TravelHealthData.categoryInfo,
      getPrice: TravelHealthData.getPrice,
      faqTitle: TravelHealthData.faqTitle,
      faqTitleDesc: TravelHealthData.faqTitleDesc,
      questions: TravelHealthData.questions,
      formData: {
        description: {
          upperText: 'Seyahatleriniz Güvende',
          title: 'En Ucuz Seyahat Sağlık Sigortası Ücretleri',
          bottomText: 'Yurtiçi - Yurt Dışı Seyahat Sağlık Sigortası Teklifi'
        },
        button: 'TEKLİF AL',
        fullname: true,
        identity: true,
        phone: true,
        email: true
      },
      quoteCard: {
        title: 'Alokasko İle Seyahatleri Güvence Altına Almak Çok Kolay!',
        description:
          'Hem yurtiçi hem de yurt dışı seyahatlerinde meydana gelebilecek riskleri güvence altına alın.',
        content: [
          {
            id: 1,
            icon: 'fas fa-file-alt',
            title: 'Stressiz Seyahat',
            desc:
              'Seyahat sağlık sigortası güvenliğinizi ve stressiz seyahat etmenizi sağlar. İster tatil ister iş için seyahat ediyor olun, en iyi seyahat sağlık sigortasını satın alabilirsiniz.'
          },
          {
            id: 2,
            icon: 'fab fa-cc-visa',
            title: 'Kaza ve Hastalık Tıbbi Harcamaları',
            desc:
              'Seyahat süresi boyunca meydana gelebilecek ani tıbbi durumlar karşılanır. Sizi maddi yük oluşturabilecek kaza veya hastalık nedeniyle öngörülemeyen durumlardan korur.'
          },
          {
            id: 3,
            icon: 'fas fa-clipboard-check',
            title: 'Bagaj Gecikmesi / Kaybı',
            desc:
              'Bagajınız kaybolursa veya gecikirse sorun yaşamazsınız. Bagajınızın bulmasını ve size ulaştırılmasını sağlanır.'
          },
          {
            id: 4,
            icon: 'fas fa-users-cog',
            title: 'Kaçırılan Uçuşlar',
            desc:
              'Mümkün olmayan durumlar neticesinde uçuşu kaçırırsanız teminat limiti kadar yeni uçuşunuz karşılanacaktır.'
          }
        ]
      }
    }
  },
  mounted () {
    this.filterButtons('Seyahat Sağlık Sigortası')
  }
}
</script>
<style lang="scss">
@import '@/css/app.scss';
</style>
